'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Axes for a cubic puzzle
 */
var Axes = exports.Axes = {
  X: 'X',
  Y: 'Y',
  Z: 'Z'
};

/**
 * Mapping from face to axis around which it turns
 */


var FaceAxisInfo = exports.FaceAxisInfo = {
  R: Axes.X,
  L: Axes.X,
  U: Axes.Y,
  D: Axes.Y,
  F: Axes.Z,
  B: Axes.Z
};

/**
 * List of faces
 */
var FaceList = exports.FaceList = Object.keys(FaceAxisInfo);

/**
 * Map of Faces.
 * @example
 * import { Faces } from 'scramble-generator';
 * Faces.R; // 'R'
 * Faces.U; // 'U'
 */
var Faces = exports.Faces = FaceList.reduce(function (map, face) {
  return Object.assign(map, _defineProperty({}, face, face));
}, {});

/**
 * Mapping of name constant to corresponding scramble modifier
 */
var Modifiers = exports.Modifiers = {
  INVERTED: "'",
  DOUBLE: '2',
  WIDE: 'w'
};

/**
 * Creates a move for a scramble.
 * @returns An object representing a move for a scramble
 */
var createMove = exports.createMove = function createMove() {
  var move = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _move$face = move.face,
      face = _move$face === undefined ? Faces.R : _move$face,
      _move$inverted = move.inverted,
      inverted = _move$inverted === undefined ? false : _move$inverted,
      _move$double = move.double,
      double = _move$double === undefined ? false : _move$double,
      _move$layerCount = move.layerCount,
      layerCount = _move$layerCount === undefined ? 1 : _move$layerCount;

  return {
    face: face,
    inverted: !double && inverted,
    double: double,
    layerCount: layerCount
  };
};